import * as React from 'react';
import { Text, Box } from '@wix/design-system';
import { AcceptedPaymentMethodIcons } from './AcceptedPaymentMethodIcons';
import s from './AcceptedPaymentMethods.scss';
import { useComponentsTranslations } from '../../../providers';
export const AcceptedPaymentMethods = ({ acceptedPaymentMethods }) => {
    const { t } = useComponentsTranslations();
    const paymentMethods = acceptedPaymentMethods;
    return (React.createElement(Box, { direction: "vertical" },
        React.createElement(Text, { weight: "bold", size: "tiny", className: s.title }, t('page_footer.accepted_payment_methods')),
        React.createElement(AcceptedPaymentMethodIcons, { paymentMethods: paymentMethods })));
};
//# sourceMappingURL=AcceptedPaymentMethods.js.map